import React from 'react';

export const TableHeader = ({ className = '', center = false, width = '', value = '' }) => {
  return (
    <th
      className={`${center ? 'text-center' : ''} ${className}`}
      scope="col"
      style={{ width, backgroundColor: '#ffe900' }}>
      {value}
    </th>
  );
};
